import { useEffect, useRef } from 'react'
import { Appointment } from '@myapp/contract'
import { findAppointmentById } from '../../../shared/lib/blockRanges'

interface Options {
  appointmentId: string | undefined
  technicians: { technicianId: string; appointments: Appointment[] }[] | undefined
  onHydrate: (appointment: Appointment) => void
  onEditingAppointmentLoaded: ((appointment: Appointment) => void) | undefined
}

export function useAppointmentEdit({
  appointmentId,
  technicians,
  onHydrate,
  onEditingAppointmentLoaded,
}: Options) {
  const editingAppointment =
    appointmentId && technicians ? findAppointmentById(technicians, appointmentId) : undefined

  const loadedRef = useRef<string | null>(null)
  useEffect(() => {
    if (editingAppointment && loadedRef.current !== editingAppointment.id) {
      loadedRef.current = editingAppointment.id
      onHydrate(editingAppointment)
      onEditingAppointmentLoaded?.(editingAppointment)
    }
    if (!appointmentId) {
      loadedRef.current = null
    }
  }, [editingAppointment, appointmentId, onHydrate, onEditingAppointmentLoaded])

  return { editingAppointment }
}
